import React, { useCallback, useMemo } from 'react';
import moment from 'moment';

import { List } from '../../components';

import { useRefreshPage } from '../../hooks/useRefreshPage';
import { ListContainer } from '../../containers';
import ServiceRunListItem from './ServiceRunListItem';


const ServiceRunList = ({
	items: serviceruns,
	refetch,
	refetchModeData,
	customControls,
	onRunPress,
}) => {

	const refetchMyDay = useCallback(() => {
		const requests = [refetch()];
		if (refetchModeData) {
			requests.push(refetchModeData());
		}

		return Promise.all(requests);
	}, [refetch, refetchModeData]);
	const [refreshPage, isRefreshing] = useRefreshPage(refetchMyDay);

	const nextRunDay = useMemo(() => serviceruns && serviceruns.reduce((acc, item) => {
		if (acc === null) {
			return item.planned;
		}

		if (moment(item.planned).isAfter(moment.utc(), 'days') && moment(item.planned).isBefore(acc, 'days')) {
			return item.planned;
		}

		return acc;
	}, null), [serviceruns]);

	const enhancedServiceRuns = useMemo(() => serviceruns && serviceruns.map(run => {
		if (moment(run.planned).isAfter(nextRunDay, 'days')) {
			return {
				...run,
				isFuture: true,
			};
		}

		return run;
	}), [serviceruns, nextRunDay]);
	const customProps = useMemo(() => (onRunPress ? { onRunPress } : undefined), [onRunPress]);

	return (
		<List
			items={enhancedServiceRuns}
			listItemComponent={ServiceRunListItem}
			onRefresh={refreshPage}
			isRefreshing={isRefreshing}
			emptyListMessage="There are no service runs to display"
			autoScrollTop={true}
			showControls={true}
			assembler={[]}
			removeTopMargin={true}
			customControls={customControls}
			customProps={customProps}
		/>
	);
};

export default ListContainer(ServiceRunList);
